import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnDestroy, Output, ViewChild } from '@angular/core';
import { BookingService } from 'src/app/services/booking.service';
import {
  OrderModel,
  PaymentTransactionStatusType,
  StripeOrderResultModel,
  StripePaymentIntent,
  OrderResultModel,
  OrderResponseStatus,
} from 'src/app/models/order.model';
import { StripeService } from 'src/app/services/stripe.service';
import { StripeCardElement } from '@stripe/stripe-js';

@Component({
  selector: 'app-cart-payment',
  templateUrl: './cart-payment.component.html',
  styleUrls: ['./cart-payment.component.scss'],
})
export class CartPaymentComponent implements AfterViewInit, OnDestroy {
  @Input() public amount: number;
  @Input() public orderData: OrderModel;
  @Input() public symbol: string;
  @ViewChild('cardInfo') cardInfo: ElementRef;
  @ViewChild('payButton') payButton: ElementRef;
  @Output() public response = new EventEmitter<any>();

  public card: StripeCardElement;
  public error: string;
  public prButton: any;

  processingForm = false;

  constructor(private _bookingService: BookingService, private _stripeService: StripeService) {}

  public ngAfterViewInit() {
    this._stripeService.elements().then((elements) => {
      this.card = elements.create('card', { hidePostalCode: true });
      this.card.mount(this.cardInfo.nativeElement);
    });
  }

  public ngOnDestroy() {
    this.card.destroy();
  }

  public async sendRequest() {
    this.processingForm = true;
    const result = await this._stripeService.createPaymentMethod(this.card);

    if (result.error) {
      this.processingForm = false;
      this.response.emit({ type: 'error' });
    } else {
      const response = await this._bookingService
        .placeOrder({ ...this.orderData, stripePaymentMethodId: result.paymentMethod.id })
        .catch((error) => ({ error } as OrderResultModel));

      if (response.status === OrderResponseStatus.Succeeded) {
        this.handleServerResponse(response as StripeOrderResultModel);
      } else {
        this.response.emit({ type: 'error', response });
      }
    }
  }

  public async handleServerResponse(response: StripeOrderResultModel) {
    const success = await this.getPaymentConfirmation(response.paymentIntent).catch(() => false);

    if (success) {
      this.response.emit({ type: 'success' });
    } else {
      this.response.emit({ type: 'error' });
    }
  }

  private async getPaymentConfirmation(paymentIntent: StripePaymentIntent): Promise<boolean> {
    if (paymentIntent.status == PaymentTransactionStatusType.Failed) {
      return false;
    }

    if (paymentIntent.status == PaymentTransactionStatusType.RequiresAction) {
      const result = await this._stripeService.confirmCardPayment(paymentIntent);

      if (result.error) {
        return false;
      }

      const { id, status } = result.paymentIntent;
      await this._bookingService.confirmStripePayment({ paymentIntentId: id, stripeStatus: status });
    }

    return true;
  }
}
